import { Row } from 'antd';
import { Link } from 'react-router-dom';
import { ArrowRight, Fire } from '@phosphor-icons/react';
import Bots from '~/pages/WorkflowMgr/Bots/list';

import './index.less';

const RecommendedSection = () => {
  return (
    <section className="home-recommended" id="recommended">
      <div className="home-recommended__backdrop" aria-hidden>
        <span className="home-recommended__grid" />
        <span className="home-recommended__orb home-recommended__orb--1" />
        <span className="home-recommended__orb home-recommended__orb--2" />
      </div>

      <div className="container home-recommended__inner">
        <header className="home-section-head">
          <span className="home-section-eyebrow">工作流精选</span>
          <h2 className="home-section-title">每日推荐工作流</h2>
          <p className="home-section-desc">精选优质智能体，把成熟的工作流直接导入你的扣子空间。</p>
        </header>

        <div className="home-recommended__bar">
          <span className="home-recommended__hint">
            <Fire size={16} weight="fill" aria-hidden />
            持续更新中的高热度工作流
          </span>
          <Link className="home-recommended__more" to="/workflow">
            查看全部工作流
            <ArrowRight size={16} weight="bold" aria-hidden />
          </Link>
        </div>

        <Row className="home-recommended__grid-row" gutter={[20, 20]}>
          <Bots isTopBots={true} />
        </Row>
      </div>
    </section>
  );
};

export default RecommendedSection;
